import React, { FC, createElement } from 'react';

interface Props extends React.HTMLProps<HTMLInputElement> {
  htmlType?: 'input' | 'textarea';
}

export const Input: FC<Props> = ({ htmlType = 'input', ...props }: Props) => {
  return createElement(htmlType, { ...props });
};
